export const FEATURE_GATES_DB_NAME = 'feature-gates-client';

export const EXPERIMENT_VALUES_TIMESTAMP_INDEX = 'experiment-values-timestamp-index';
export const CLIENT_SDK_KEY_TIMESTAMP_INDEX = 'client-sdk-key-timestamp-index';

export const INDEXEDDB_TIMEOUT = 15000;

export enum StoreName {
	EXPERIMENT_VALUES_STORE_NAME = 'experiment-values-store',
	CLIENT_SDK_KEY_STORE_NAME = 'client-sdk-key-store',
}
